/* eslint-disable @typescript-eslint/no-explicit-any */
import { AppThunkAction, AppThunkDispatch } from '../../thunk';
import ResponseError from '../../../types/response/ResponseError';
import {
    getReportsStarted,
    getReportsFailed,
    generateReportStarted,
    generateReportSucceeded,
    generateReportsFailed,
    getReportDownloadTokenSucceeded,
    downloadCsvFailed,
    setDownloadCsvProcessing,
    getPagedReportsSucceeded,
} from './periodicReportsSlice';
import api from '../../../services/api';
import {
    GenerateReportFormData,
    PeriodicReport,
    PeriodicReportDownloadTokenRespone,
} from '../../../types/report/PeriodicReports';
import Logger from '../../../services/logging/logger';
import { PagingResponseData } from '../../../types/response/PagingResponseData';

const getPagedReports =
    (url: string): AppThunkAction =>
    async (dispatch: AppThunkDispatch) => {
        dispatch(getReportsStarted());
        try {
            const response = await api.get<PagingResponseData<PeriodicReport[]>>(url);
            dispatch(getPagedReportsSucceeded(response));
        } catch (error) {
            dispatch(getReportsFailed(error as ResponseError));
        }
    };

const generateReport =
    (newReportData: GenerateReportFormData) => async (dispatch: AppThunkDispatch) => {
        dispatch(generateReportStarted());
        try {
            await api.post<GenerateReportFormData>(`/periodic-reports`, newReportData);
            dispatch(generateReportSucceeded());
            await dispatch(getPagedReports(`/periodic-reports`));
        } catch (error) {
            dispatch(generateReportsFailed(error as ResponseError));
        }
    };

const getReportDownloadToken =
    (reportId: string): AppThunkAction =>
    async (dispatch: AppThunkDispatch) => {
        try {
            dispatch(setDownloadCsvProcessing(true));
            const response = await api.get<PeriodicReportDownloadTokenRespone>(
                `/periodic-reports/${reportId}/download`
            );
            dispatch(getReportDownloadTokenSucceeded(response.data));
        } catch (error) {
            dispatch(downloadCsvFailed());
            Logger.error('Failed to get report download token', error);
        }
    };

export default {
    getPagedReports,
    generateReport,
    getReportDownloadToken,
};
